import { useApp } from '../../AppContext';
import React, { useState, useMemo, useEffect, useCallback } from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import { getDiscountedPrice } from "../../Utils";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { updateBook, moveBook } from "./UpdateBook";
import AppDataTable from '../../components/AppDataTable';
import { fetchDeletedBooks } from '../../apiCalls';
import { showConfirm } from '../../ConfirmBox';
export default function OldBooks() {
    const { books, setBooks, oldBooks, setOldBooks } = useApp();
    const fetchBooks = async () => {
        try {
            const booksData = await fetchDeletedBooks();
            setOldBooks(booksData);
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        if (oldBooks.length === 0) {
            fetchBooks();
        }
    }, []);


    const navigate = useNavigate();
    const [search, setSearch] = useState("");

    const handleView = (row) => {
        navigate(`/view-book/${row.book_id}`);
    };

    const handleEdit = (row) => {
        navigate(`/update-book/${row.book_id}`);
    };

    const handleRestore = async (row) => {
        showConfirm(
            "Restore Book",
            `Are you sure you want to restore "${row.book_name}" to the active list?`,
            async () => {
                try {
                    const response = await updateBook(
                        { status: "ENABLED" },
                        row.book_id
                    );

                    if (response?.status) {
                        moveBook(
                            row.book_id,
                            setOldBooks,   // from
                            setBooks,      // to
                            row,
                            "ENABLED"
                        );
                    }
                }
                catch (error) {
                    console.error("Restore failed:", error);
                }
            }
        );
    };

    // 🔥 Filtered Data
    const filteredData = useMemo(() => {
        return oldBooks.filter((book) =>
            book.book_name.toLowerCase().includes(search.toLowerCase()) ||
            book.category_name.toLowerCase().includes(search.toLowerCase())
        );
    }, [oldBooks, search]);

    const columns = [
        {
            name: "#",
            width: "70px",
            cell: (row, index) => index + 1,
        },
        {
            name: "Book Title",
            selector: row => row.book_name,
            sortable: true,
        },
        {
            name: "Category",
            selector: row => row.category_name,
            sortable: true,
        },
        {
            name: "MRP",
            selector: row => `₹ ${row.mrp}`,
            sortable: true,
        },
        {
            name: "Discount %",
            selector: row => row.discount_percent + "%",
            sortable: true,
        },
        {
            name: "Discounted Price",
            selector: row => `₹ ${getDiscountedPrice(row.mrp, row.discount_percent)}`,
            sortable: true,
        },
        {
            name: "Action",
            width: "120px",
            cell: (row) => (
                <div className="d-flex gap-3 fs-5">
                    <i
                        className="bi bi-eye text-info"
                        data-tooltip-id="viewTooltip"
                        data-tooltip-content="View Book"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleView(row)}
                    ></i>

                    <i
                        className="bi bi-pencil text-warning"
                        data-tooltip-id="editTooltip"
                        data-tooltip-content="Edit Book"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleEdit(row)}
                    ></i>

                    <i
                        className="bi-arrow-counterclockwise text-primary"
                        data-tooltip-id="restoreTooltip"
                        data-tooltip-content="Restore Book"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleRestore(row)}
                    ></i>
                </div>
            ),
            ignoreRowClick: true,
        }
    ];
    return (
        <>
            <div className='page-title-container'>

                <h2>Our Old Books <span>List of all our old books | View, Edit or Restore the books</span></h2>
            </div>
            <div className="table-responsive">
                <AppDataTable
                    columns={columns}
                    data={filteredData}
                />
            </div>

            <Tooltip id="viewTooltip" />
            <Tooltip id="editTooltip" />
            <Tooltip id="restoreTooltip" />
        </>
    )
}
